import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [creds, setCreds] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ error: null, message: "" });
  const onSubmit = async (e) => {
    e.preventDefault();
    setError({ error: null, message: "" });
    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/login`, {
        email: creds.email,
      password: creds.password,
    });
    
      localStorage.setItem("auth-token", response.data.token);
      navigate("/all-messages");
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setError({ error: true, message: error.response.data.error });
      setIsLoading(false);
    }
  };
  return (
    <>
      <form
        onSubmit={onSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "1rem",
        }}
      >
        <input
          type="email"
          placeholder="Email"
          value={creds.email}
          style={{ padding: "0.5rem", borderRadius: "0.5rem", border: "1px solid #ccc" }}
          onChange={(e) => setCreds({ ...creds, email: e.target.value })}
        />
        <input
          type="password"
          placeholder="Password"
          value={creds.password}
          style={{
            padding: "0.5rem",
            borderRadius: "0.5rem",
            border: "1px solid #ccc",
          }}
         
          onChange={(e) => setCreds({ ...creds, password: e.target.value })}
        />
        <button
          type="submit"
          style={{
            padding: "0.5rem",
            borderRadius: "0.5rem",
            border: "1px solid #ccc",
            backgroundColor: isLoading ? "#ccc" : "green",
            color: "white",
          }}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Login"}
        </button>
        {error.error && <p style={{ color: "red" }}>{error.message}</p>}
      </form>
    </>
  );
}
